import {
  REQUEST_SOCIAL_PLATFORM_KEYS_SUCCESS,
  REQUEST_SOCIAL_PLATFORM_KEYS_FAILURE
} from '../constants/actionTypes';

const INITIAL_STATE = { ids: [], error: null };

export default function socialPlatformAppKeys(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_SOCIAL_PLATFORM_KEYS_SUCCESS:
      return {
        ids: [
          ...state.ids,
          {
            id: parseInt(action.payload.data.id, 10),
            platform: action.payload.name,
            socialPlatformId: action.payload.socialPlatformId
          }
        ],
        error: null
      };
    case REQUEST_SOCIAL_PLATFORM_KEYS_FAILURE:
      return {
        ...state,
        ids: [],
        error: action.payload.message
      };
    default:
      return state;
  }
}
